import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function Anexo30Y31Ano2023SistemasDeMedicion() {
  return <CategoryPage category="anexo30Y31Ano2023SistemasDeMedicion" pageTitle="Sistemas De Medicion 2023" />;
}

export default Anexo30Y31Ano2023SistemasDeMedicion;
